/**
 * Shared external link targets. Single source of truth so the GitHub URL
 * is identical in the header `ActionIcon`, the login footer, and any
 * future surface (CHANGELOG link in About modal, etc.).
 */
export const GITHUB_URL = "https://github.com/kruchenburger/another-s3-manager";
